export const calculatePosition = (
  triggerRef: any,
  portalRef: any,
  arrowRef: any,
  place: any,
  offset: any
) => {
  let top = 0
  let left = 0
  let arrowTop = 0
  let arrowLeft = 0
  let newPlace = place
  if (
    !portalRef ||
    !portalRef.current ||
    !triggerRef ||
    !triggerRef.current ||
    !arrowRef ||
    !arrowRef.current
  ) {
    return {
      top,
      left,
      arrowTop,
      arrowLeft,
      place: newPlace,
    }
  }
  const docWidth = document.documentElement.clientWidth
  const docHeight = document.documentElement.clientHeight
  const trRect = triggerRef.current.getBoundingClientRect()
  const ttRect = portalRef.current.getBoundingClientRect()
  const arrRect = arrowRef.current.getBoundingClientRect()
  const rx = trRect.x + trRect.width
  const lx = trRect.x
  const ty = trRect.y
  const by = trRect.y + trRect.height
  const { scrollX, scrollY } = window
  if (
    Number.isNaN(rx) ||
    Number.isNaN(lx) ||
    Number.isNaN(ty) ||
    Number.isNaN(by)
  ) {
    return {
      top,
      left,
      arrowTop,
      arrowLeft,
      place: newPlace,
    }
  }
  const bRight = rx + ttRect.width <= scrollX + docWidth
  const bLeft = lx - ttRect.width >= 0
  const bAbove = ty - ttRect.height >= 0
  const bBelow = by + ttRect.height <= scrollY + docHeight
  switch (place) {
    case "top":
      if (bAbove) {
        top = ty - ttRect.height - offset + scrollY
        arrowTop = top + ttRect.height
      } else {
        top = by + offset + scrollY
        arrowTop = top - arrRect.height
        newPlace = "bottom"
      }
      left = lx + scrollX + (trRect.width - ttRect.width) / 2
      arrowLeft = lx + scrollX + (trRect.width - arrRect.width) / 2
      if (left + ttRect.width > docWidth + scrollX) {
        left = rx - ttRect.width + scrollX
      } else if (left < 0) {
        left = lx + scrollX
      }
      break
    case "bottom":
      if (bBelow) {
        top = by + offset + scrollY
        arrowTop = top - arrRect.height
      } else {
        top = ty - ttRect.height - offset + scrollY
        arrowTop = top + ttRect.height
        newPlace = "top"
      }
      left = lx + scrollX + (trRect.width - ttRect.width) / 2
      arrowLeft = lx + scrollX + (trRect.width - arrRect.width) / 2
      if (left + ttRect.width > docWidth + scrollX) {
        left = rx - ttRect.width + scrollX
      } else if (left < 0) {
        left = lx + scrollX
      }
      break
    case "left":
      if (bLeft) {
        left = lx - ttRect.width - offset + scrollX
        arrowLeft = left + ttRect.width
      } else {
        left = rx + offset + scrollX
        arrowLeft = left - arrRect.width
        newPlace = "right"
      }
      top = ty + scrollY + (trRect.height - ttRect.height) / 2
      arrowTop = ty + scrollY + (trRect.height - arrRect.height) / 2
      if (top + ttRect.height > docHeight + scrollY) {
        top = by - ttRect.height + scrollY
      } else if (top < 0) {
        top = ty + scrollY
      }
      break
    case "right":
      if (bRight) {
        left = rx + offset + scrollX
        arrowLeft = left - arrRect.width
      } else {
        left = lx - ttRect.width - offset + scrollX
        arrowLeft = left + ttRect.width
        newPlace = "left"
      }
      top = ty + scrollY + (trRect.height - ttRect.height) / 2
      arrowTop = ty + scrollY + (trRect.height - arrRect.height) / 2
      if (top + ttRect.height > docHeight + scrollY) {
        top = by - ttRect.height + scrollY
      } else if (top < 0) {
        top = ty + scrollY
      }
      break
    default:
      break
  }
  return {
    top,
    left,
    arrowTop,
    arrowLeft,
    place: newPlace,
  }
}
